import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, tone = "dark" }) => (
  <div className="flex items-center gap-3 mb-5">
    <span
      className={`h-px w-10 ${tone === "dark" ? "bg-[#D4AF37]" : "bg-[#22D3EE]"}`}
    />
    <span
      className={`text-xs font-semibold tracking-[0.28em] uppercase ${
        tone === "dark" ? "text-[#B08D2A]" : "text-[#22D3EE]"
      }`}
    >
      {children}
    </span>
  </div>
);
